let maima = {
    isPc: document.documentElement.clientWidth > 750 ? true : false,
    install(Vue) {
        Vue.prototype.$maima = maima;
    },
    // 导航按钮点击
    index_top_menu_btn_click(name){
        if(this.isPc){
            // console.log('maima, pc_index_top_menu_btn_click', name);
            _hw("send", "action", "pc_index_top_menu_btn_click", {
                pc_top_menu_btn_name: name
            });
        }else{
            // console.log('maima, wap_index_menu_click', name);
            _hw("send", "action", "wap_index_menu_click", {
                wap_index_menu_btn_name: name
            });
        }
    },
    // 返回华为首页
    index_officialweb_btn_click(){
        if(this.isPc){
            // console.log('maima, pc_index_officialweb_btn_click');
            _hw("send", "action", "pc_index_officialweb_btn_click");
        }else{
            return;
        }
    },
    // 首页参会报名按钮
    index_meetingregister_btn_click(name='', location='', date=''){
        if(this.isPc){
            // console.log('maima, pc_index_meetingregister_btn_click');
            _hw("send", "action", "pc_index_meetingregister_btn_click");
        }else{
            // console.log('maima, wap_index_meetingregister_btn_click', name, location, date);
            _hw("send", "action", "wap_index_meetingregister_btn_click", {
                wap_index_banner_meeting_name: name,
                wap_index_banner_meeting_location: location,
                wap_index_banner_meeting_date: date,
            });
        }
    },
    // 首页预约直播按钮
    index_bookinglive_btn_click(name='', location='', date=''){
        if(this.isPc){
            // console.log('maima, pc_index_bookinglive_btn_click');
            _hw("send", "action", "pc_index_bookinglive_btn_click");
        }else{
            // console.log('maima, wap_index_bookinglive_btn_click', name, location, date);
            _hw("send", "action", "wap_index_bookinglive_btn_click", {
                wap_index_banner_meeting_name: name,
                wap_index_banner_meeting_location: location,
                wap_index_banner_meeting_date: date,
            });
        }
    },
    // 首页点击大会议程tab
    index_agenda_tab_click(name, DateStr){
        if(this.isPc){
            // console.log('maima, pc_index_agenda_tab_click', name, DateStr);
            _hw("send", "action", "pc_index_agenda_tab_click", {
                pc_index_agenda_btn_name: name,
                pc_meeting_date: DateStr
            });
        }else{
            // console.log('maima, wap_index_meeting_agenda_meeting_form_select_click', name, DateStr);
            _hw("send", "action", "wap_index_meeting_agenda_meeting_form_select_click", {
                wap_meeting_date: DateStr,
                wap_meeting_type: name,
                wap_meeting_name: '',
            });
        }
    },
    // 首页_大会议程_点击选择日期
    index_meeting_agenda_meeting_form_select_click(DateStr){
        if(this.isPc){
            return;
        }else{
            // console.log('maima, wap_index_meeting_agenda_meeting_form_select_click', DateStr);
            _hw("send", "action", "wap_index_meeting_agenda_meeting_form_select_click", {
                wap_meeting_date: DateStr,
            });
        }
    },
    // 首页-查看热门资讯位
    index_news_btn_click(index, name, product_tag, industry_tag){
        if(this.isPc){
            let actionName = 'pc_index_news_btn'+index+'_click';
            // console.log('maima, ' + actionName, index, name, product_tag, industry_tag);
            _hw("send", "action", actionName, {
                pc_hotnews_name: name,
                pc_product_tag: product_tag,
                pc_industry_tag: industry_tag
            });
        }else{
            // console.log('maima, wap_index_latest_news_newsinfo_click', index, name, product_tag, industry_tag);
            _hw("send", "action", 'wap_index_latest_news_newsinfo_click', {
                wap_newsinfo_name: name,
                wap_product_tag: product_tag,
                wap_industry_tag: industry_tag
            });
        }
    },
    // 首页_众筹伙伴_点击赞助商类别
    index_crowdfunding_partner_sponsor_type_click(type){
        if(this.isPc){
            return;
            let actionName = 'pc_index_news_btn'+index+'_click';
            // console.log('maima, ' + actionName, index, name, product_tag, industry_tag);
            _hw("send", "action", actionName, {
                pc_hotnews_name: name,
                pc_product_tag: product_tag,
                pc_industry_tag: industry_tag
            });
        }else{
            // console.log('maima, wap_index_crowdfunding_partner_sponsor_type_click', type);
            _hw("send", "action", 'wap_index_crowdfunding_partner_sponsor_type_click', {
                wap_sponsor_type: type,
            });
        }
    },
    // 首页_众筹伙伴_点击赞助商logo
    index_crowdfunding_partner_sponsor_logo_click(name){
        if(this.isPc){
            return;
            let actionName = 'pc_index_news_btn'+index+'_click';
            // console.log('maima, ' + actionName, index, name, product_tag, industry_tag);
            _hw("send", "action", actionName, {
                pc_hotnews_name: name,
                pc_product_tag: product_tag,
                pc_industry_tag: industry_tag
            });
        }else{
            // console.log('maima, wap_index_crowdfunding_partner_sponsor_logo_click', name);
            _hw("send", "action", 'wap_index_crowdfunding_partner_sponsor_logo_click', {
                wap_sponsor_name: name,
            });
        }
    },
    // 首页-点击联系我们
    index_contact_us_click(){
        if(this.isPc){
            // console.log('maima, pc_index_contact_us_click');
            _hw("send", "action", "pc_index_contact_us_click");
        }else{
            // console.log('maima, wap_index_contact_us_click');
            _hw("send", "action", "wap_index_contact_us_click");
        }
    },
    // 首页反馈需求按钮
    index_feedback_btn_click(){
        if(this.isPc){
            // console.log('maima, pc_index_feedback_btn_click');
            _hw("send", "action", "pc_index_feedback_btn_click");
        }else{
            // console.log('maima, wap_index_feedback_btn_click');
            _hw("send", "action", "wap_index_feedback_btn_click");
        }
    },
    // 首页项目咨询按钮
    index_consultation_btn_click(){
        if(this.isPc){
            // console.log('maima, pc_index_consultation_btn_click');
            _hw("send", "action", "pc_index_consultation_btn_click");
        }else{
            // console.log('maima, wap_index_consultation_btn_click');
            _hw("send", "action", "wap_index_consultation_btn_click");
        }
    },
    // 首页-点击精彩视频
    index_video_review_click(name){
        if(this.isPc){
            // console.log('maima, pc_index_video_review_click', name);
            _hw("send", "action", "pc_index_video_review_click", {
                video_name: name,
            });
        }else{
            // console.log('maima, wap_index_video_replay_video_click', name);
            _hw("send", "action", "wap_index_video_replay_video_click", {
                wap_video_name: name,
            });
            return;
        }
    },
    // 首页_点击查看更多+查看全部
    index_check_more_all_click(name){
        if(this.isPc){
            // console.log('maima, pc_index_check_more_all_click', name);
            _hw("send", "action", "pc_index_check_more_all_click", {
                pc_module_name: name,
            });
        }else{
            // console.log('maima, wap_index_check_more_all_click', name);
            _hw("send", "action", "wap_index_check_more_all_click", {
                wap_index_check_more_all_click: name,
            });
        }
    },
    // 大会议程页-搜索
    agenda_page_search_click(keywords){
        if(this.isPc){
            // console.log('maima, pc_agenda_page_search_click', keywords);
            _hw("send", "action", "pc_agenda_page_search_click", {
                pc_meeting_agenda_search_keyword: keywords,
            });
        }else{
            // console.log('maima, wap_agenda_meeting_search', keywords);
            _hw("send", "action", "wap_agenda_meeting_search", {
                wap_meeting_agenda_search_keyword: keywords,
            });
        }
    },
    // 大会议程页_点击选择日期
    agenda_date_select_click( DateStr){
        if(this.isPc){
            return;
        }else{
            // console.log('maima, wap_agenda_date_select_click', DateStr);
            _hw("send", "action", "wap_agenda_date_select_click", {
                wap_meeting_date: DateStr
            });
        }
    },
    // 大会议程页-点击大会议程tab
    agenda_page_tab_click(name, DateStr){
        if(this.isPc){
            // console.log('maima, pc_agenda_page_tab_click', name, DateStr);
            _hw("send", "action", "pc_agenda_page_tab_click", {
                pc_index_agenda_btn_name: name,
                pc_meeting_date: DateStr
            });
        }else{
            // console.log('maima, wap_agenda_meeting_type_click', name, DateStr);
            _hw("send", "action", "wap_agenda_meeting_type_click", {
                wap_meeting_date: DateStr,
                wap_meeting_type: name,
                wap_meeting_name: '',
            });
            return;
        }
    },
    // 大会议程页-点击议程筛选确认
    agenda_screen_confirm_click(content){
        if(this.isPc){
            // console.log('maima, pc_index_agenda_screen_confirm_click', content);
            _hw("send", "action", "pc_index_agenda_screen_confirm_click", {
                pc_content_name: content,
            });
        }else{
            // console.log('maima, wap_index_agenda_screen_confirm_click', content);
            _hw("send", "action", "wap_index_agenda_screen_confirm_click", {
                wap_content_name: content,
            });
        }
    },
    // 大会资讯页-搜索
    news_page_search_click(keywords){
        if(this.isPc){
            // console.log('maima, pc_news_page_search_click', keywords);
            _hw("send", "action", "pc_news_page_search_click", {
                pc_meeting_news_search_keyword: keywords
            });
        }else{
            // console.log('maima, wap_meeting_news_search', keywords);
            _hw("send", "action", "wap_meeting_news_search", {
                wap_meeting_news_search_keyword: keywords
            });
        }
    },
    // 大会资讯页-点击资讯内容
    news_page_news_click(name, product_tag, industry_tag){
        if(this.isPc){
            // console.log('maima, pc_news_page_news_click', name, product_tag, industry_tag);
            _hw("send", "action", "pc_news_page_news_click", {
                pc_hotnews_name: name,
                pc_product_tag: product_tag,
                pc_industry_tag: industry_tag,
            });
        }else{
            // console.log('maima, wap_meeting_news_newsinfo_detail_click', name, product_tag, industry_tag);
            _hw("send", "action", "wap_meeting_news_newsinfo_detail_click", {
                wap_newsinfo_name: name,
                wap_product_tag: product_tag,
                wap_industry_tag: industry_tag,
            });
        }
    },
    // 众筹伙伴页-点击赞助商
    partner_page_company_click(name, type){
        if(this.isPc){
            // console.log('maima, pc_partner_page_company_click', name, type);
            _hw("send", "action", "pc_partner_page_company_click", {
                pc_sponsor_name: name,
                pc_sponsor_type: type,
            });
        }else{
            // console.log('maima, wap_crowdfunding_partner_click', name, type);
            _hw("send", "action", "wap_crowdfunding_partner_click", {
                wap_sponsor_name: name,
                wap_sponsor_type: type,
            });
        }
    },
    // 精彩视频页-点击视频
    ireview_page_video_click(name){
        if(this.isPc){
            // console.log('maima, pc_ireview_page_video_click', name);
            _hw("send", "action", "pc_ireview_page_video_click", {
                pc_video_name: name,
            });
        }else{
            // console.log('maima, wap_video_replay_video_click', name);
            _hw("send", "action", "wap_video_replay_video_click", {
                wap_video_name: name,
            });
        }
    },
    // 主题演讲-点击收藏
    agenda_keynote_collect_click(name, product_tag, industry_tag, material_name){
        if(this.isPc){
            // console.log('maima, pc_agenda_keynote_collect_click', name, product_tag, industry_tag, material_name);
            _hw("send", "action", "pc_agenda_keynote_collect_click", {
                pc_agenda_name: name,
                pc_index_agenda_btn_name: '主题演讲收藏',
                pc_product_tag: product_tag,
                pc_industry_tag: industry_tag,
                pc_material_name: material_name,
            });
        }else{
            // console.log('maima, wap_agenda_keynote_collect_click', name, product_tag, industry_tag, material_name);
            _hw("send", "action", "wap_agenda_keynote_collect_click", {
                wap_agenda_name: name,
                wap_index_agenda_btn_name: '主题演讲收藏',
                wap_product_tag: product_tag,
                wap_industry_tag: industry_tag,
                wap_material_name: material_name,
            });
        }
    },
    // 主题演讲-点击直播
    agenda_keynote_live_click(name, product_tag, industry_tag, material_name){
        if(this.isPc){
            // console.log('maima, pc_agenda_keynote_live_click', name, product_tag, industry_tag, material_name);
            _hw("send", "action", "pc_agenda_keynote_live_click", {
                pc_agenda_name: name,
                pc_index_agenda_btn_name: '主题演讲直播',
                pc_product_tag: product_tag,
                pc_industry_tag: industry_tag,
                pc_material_name: material_name,
            });
        }else{
            // console.log('maima, wap_agenda_keynote_live_click', name, product_tag, industry_tag, material_name);
            _hw("send", "action", "wap_agenda_keynote_live_click", {
                wap_agenda_name: name,
                wap_index_agenda_btn_name: '主题演讲直播',
                wap_product_tag: product_tag,
                wap_industry_tag: industry_tag,
                wap_material_name: material_name,
            });
        }
    },
    // 主题演讲-点击查看资料
    agenda_keynote_onlinereview_click(name, product_tag, industry_tag, material_name){
        if(this.isPc){
            // console.log('maima, pc_agenda_keynote_onlinereview_click', name, product_tag, industry_tag, material_name);
            _hw("send", "action", "pc_agenda_keynote_onlinereview_click", {
                pc_agenda_name: name,
                pc_index_agenda_btn_name: '主题演讲查看资料',
                pc_product_tag: product_tag,
                pc_industry_tag: industry_tag,
                pc_material_name: material_name,
            });
        }else{
            // console.log('maima, wap_agenda_keynote_onlinereview_click', name, product_tag, industry_tag, material_name);
            _hw("send", "action", "wap_agenda_keynote_onlinereview_click", {
                wap_agenda_name: name,
                wap_index_agenda_btn_name: '主题演讲查看资料',
                wap_product_tag: product_tag,
                wap_industry_tag: industry_tag,
                wap_material_name: material_name,
            });
        }
    },
    // 主题演讲-点击下载资料
    agenda_keynote_download_click(name, product_tag, industry_tag, material_name){
        if(this.isPc){
            // console.log('maima, pc_agenda_keynote_download_click', name, product_tag, industry_tag, material_name);
            _hw("send", "action", "pc_agenda_keynote_download_click", {
                pc_agenda_name: name,
                pc_index_agenda_btn_name: '主题演讲下载资料',
                pc_product_tag: product_tag,
                pc_industry_tag: industry_tag,
                pc_material_name: material_name,
            });
        }else{
            // console.log('maima, wap_agenda_keynote_download_click', name, product_tag, industry_tag, material_name);
            _hw("send", "action", "wap_agenda_keynote_download_click", {
                wap_agenda_name: name,
                wap_index_agenda_btn_name: '主题演讲下载资料',
                wap_product_tag: product_tag,
                wap_industry_tag: industry_tag,
                wap_material_name: material_name,
            });
        }
    },
    // 专题演讲-点击收藏
    agenda_expert_collect_click(name, product_tag, industry_tag, material_name){
        if(this.isPc){
            // console.log('maima, pc_agenda_expert_collect_click', name, product_tag, industry_tag, material_name);
            _hw("send", "action", "pc_agenda_expert_collect_click", {
                pc_agenda_name: name,
                pc_index_agenda_btn_name: '专题演讲收藏',
                pc_product_tag: product_tag,
                pc_industry_tag: industry_tag,
                pc_material_name: material_name,
            });
        }else{
            // console.log('maima, wap_agenda_expert_collect_click', name, product_tag, industry_tag, material_name);
            _hw("send", "action", "wap_agenda_expert_collect_click", {
                wap_agenda_name: name,
                wap_index_agenda_btn_name: '专题演讲收藏',
                wap_product_tag: product_tag,
                wap_industry_tag: industry_tag,
                wap_material_name: material_name,
            });
        }
    },
    // 专题演讲-点击直播
    agenda_expert_live_click(name, product_tag, industry_tag, material_name){
        if(this.isPc){
            // console.log('maima, pc_agenda_expert_live_click', name, product_tag, industry_tag, material_name);
            _hw("send", "action", "pc_agenda_expert_live_click", {
                pc_agenda_name: name,
                pc_index_agenda_btn_name: '专题演讲直播',
                pc_product_tag: product_tag,
                pc_industry_tag: industry_tag,
                pc_material_name: material_name,
            });
        }else{
            // console.log('maima, wap_agenda_expert_live_click', name, product_tag, industry_tag, material_name);
            _hw("send", "action", "wap_agenda_expert_live_click", {
                wap_agenda_name: name,
                wap_index_agenda_btn_name: '专题演讲直播',
                wap_product_tag: product_tag,
                wap_industry_tag: industry_tag,
                wap_material_name: material_name,
            });
        }
    },
    // 专题演讲-点击查看资料
    agenda_expert_onlinereview_click(name, product_tag, industry_tag, material_name){
        if(this.isPc){
            // console.log('maima, pc_agenda_expert_onlinereview_click', name, product_tag, industry_tag, material_name);
            _hw("send", "action", "pc_agenda_expert_onlinereview_click", {
                pc_agenda_name: name,
                pc_index_agenda_btn_name: '专题演讲查看资料',
                pc_product_tag: product_tag,
                pc_industry_tag: industry_tag,
                pc_material_name: material_name,
            });
        }else{
            // console.log('maima, wap_agenda_expert_onlinereview_click', name, product_tag, industry_tag, material_name);
            _hw("send", "action", "wap_agenda_expert_onlinereview_click", {
                wap_agenda_name: name,
                wap_index_agenda_btn_name: '专题演讲查看资料',
                wap_product_tag: product_tag,
                wap_industry_tag: industry_tag,
                wap_material_name: material_name,
            });
        }
    },
    // 专题演讲-点击下载资料
    agenda_keynote_download_click(name, product_tag, industry_tag, material_name){
        if(this.isPc){
            // console.log('maima, pc_agenda_expert_download_click', name, product_tag, industry_tag, material_name);
            _hw("send", "action", "pc_agenda_expert_download_click", {
                pc_agenda_name: name,
                pc_index_agenda_btn_name: '专题演讲下载资料',
                pc_product_tag: product_tag,
                pc_industry_tag: industry_tag,
                pc_material_name: material_name,
            });
        }else{
            // console.log('maima, wap_agenda_expert_download_click', name, product_tag, industry_tag, material_name);
            _hw("send", "action", "wap_agenda_expert_download_click", {
                wap_agenda_name: name,
                wap_index_agenda_btn_name: '专题演讲下载资料',
                wap_product_tag: product_tag,
                wap_industry_tag: industry_tag,
                wap_material_name: material_name,
            });
        }
    },
    // 开放演讲-点击收藏
    agenda_open_collect_click(name, product_tag, industry_tag, material_name){
        if(this.isPc){
            // console.log('maima, pc_agenda_open_collect_click', name, product_tag, industry_tag, material_name);
            _hw("send", "action", "pc_agenda_open_collect_click", {
                pc_agenda_name: name,
                pc_index_agenda_btn_name: '开放演讲收藏',
                pc_product_tag: product_tag,
                pc_industry_tag: industry_tag,
                pc_material_name: material_name,
            });
        }else{
            // console.log('maima, wap_agenda_open_collect_click', name, product_tag, industry_tag, material_name);
            _hw("send", "action", "wap_agenda_open_collect_click", {
                wap_agenda_name: name,
                wap_index_agenda_btn_name: '开放演讲收藏',
                wap_product_tag: product_tag,
                wap_industry_tag: industry_tag,
                wap_material_name: material_name,
            });
        }
    },
    // 重磅嘉宾页-点击嘉宾信息
    guest_page_information_click(name, company, agendaName){
        if(this.isPc){
            // console.log('maima, pc_guest_page_information_click', name, company, agendaName);
            _hw("send", "action", "pc_guest_page_information_click", {
                pc_guest_name: name,
                pc_guest_company: company,
                pc_agenda_name: agendaName,
            });
        }else{
            // console.log('maima, wap_guest_page_information_click', name, company, agendaName);
            _hw("send", "action", "wap_guest_page_information_click", {
                wap_guest_name: name,
                wap_guest_company: company,
                wap_agenda_name: agendaName,
            });
        }
    },
    // 展厅导览页-展区介绍
    exhibition_page_introduction_click(name, zipName, product_tag, industry_tag){
        if(this.isPc){
            // console.log('maima, pc_exhibition_page_introduction_click', name, zipName, product_tag, industry_tag);
            _hw("send", "action", "pc_exhibition_page_introduction_click", {
                pc_exhibition_name: name,
                pc_material_name: zipName,
                pc_product_tag: product_tag,
                pc_industry_tag: industry_tag,
            });
        }else{
            // console.log('maima, wap_exhibition_page_introduction_click', name, zipName, product_tag, industry_tag);
            _hw("send", "action", "wap_exhibition_page_introduction_click", {
                wap_exhibition_name: name,
                wap_material_name: zipName,
                wap_product_tag: product_tag,
                wap_industry_tag: industry_tag,
            });
        }
    },
    // 展厅导览页-展区资料下载
    exhibition_page_download_click(name, zipName, product_tag, industry_tag){
        if(this.isPc){
            // console.log('maima, pc_exhibition_page_download_click', name, zipName, product_tag, industry_tag);
            _hw("send", "action", "pc_exhibition_page_download_click", {
                pc_exhibition_name: name,
                pc_material_name: zipName,
                pc_product_tag: product_tag,
                pc_industry_tag: industry_tag,
            });
        }else{
            // console.log('maima, wap_exhibition_page_download_click', name, zipName, product_tag, industry_tag);
            _hw("send", "action", "wap_exhibition_page_download_click", {
                wap_exhibition_name: name,
                wap_material_name: zipName,
                wap_product_tag: product_tag,
                wap_industry_tag: industry_tag,
            });
        }
    },
    // 展厅导览页-展区资料预览
    exhibition_page_onlinereview_click(name, zipName, product_tag, industry_tag){
        if(this.isPc){
            // console.log('maima, pc_exhibition_page_onlinereview_click', name, zipName, product_tag, industry_tag);
            _hw("send", "action", "pc_exhibition_page_onlinereview_click", {
                pc_exhibition_name: name,
                pc_material_name: zipName,
                pc_product_tag: product_tag,
                pc_industry_tag: industry_tag,
            });
        }else{
            // console.log('maima, wap_exhibition_page_onlinereview_click', name, zipName, product_tag, industry_tag);
            _hw("send", "action", "wap_exhibition_page_onlinereview_click", {
                wap_exhibition_name: name,
                wap_material_name: zipName,
                wap_product_tag: product_tag,
                wap_industry_tag: industry_tag,
            });
        }
    },
    // 展厅导览页-行业解决方案
    exhibition_page_solution_click(name, solution_name, product_tag, industry_tag){
        if(this.isPc){
            // console.log('maima, pc_exhibition_page_solution_click', name, solution_name, product_tag, industry_tag);
            _hw("send", "action", "pc_exhibition_page_solution_click", {
                pc_exhibition_name: name,
                pc_solution_name: solution_name,
                pc_product_tag: product_tag,
                pc_industry_tag: industry_tag,
            });
        }else{
            // console.log('maima, wap_exhibition_page_solution_click', name, solution_name, product_tag, industry_tag);
            _hw("send", "action", "wap_exhibition_page_solution_click", {
                wap_exhibition_name: name,
                wap_solution_name: solution_name,
                wap_product_tag: product_tag,
                wap_industry_tag: industry_tag,
            });
        }
    },
    // 展厅导览页-合作伙伴
    exhibition_page_partner_click(name, sponsor_name){
        if(this.isPc){
            // console.log('maima, pc_exhibition_page_partner_click', name, sponsor_name);
            _hw("send", "action", "pc_exhibition_page_partner_click", {
                pc_exhibition_name: name,
                pc_sponsor_name: sponsor_name,
            });
        }else{
            // console.log('maima, wap_exhibition_page_partner_click', name, sponsor_name);
            _hw("send", "action", "wap_exhibition_page_partner_click", {
                wap_exhibition_name: name,
                wap_sponsor_name: sponsor_name,
            });
        }
    },
    // 展厅导览页-顶部tab按钮
    exhibition_page_top_tab_click(name, product_tag, industry_tag){
        if(this.isPc){
            // console.log('maima, pc_exhibition_page_top_tab_click', name, product_tag, industry_tag);
            _hw("send", "action", "pc_exhibition_page_top_tab_click", {
                pc_exhibition_hall_name: name,
                pc_product_tag: product_tag,
                pc_industry_tag: industry_tag,
            });
        }else{
            // console.log('maima, wap_exhibition_page_top_tab_click', name, product_tag, industry_tag);
            _hw("send", "action", "wap_exhibition_page_top_tab_click", {
                wap_exhibition_hall_name: name,
                wap_product_tag: product_tag,
                wap_industry_tag: industry_tag,
            });
        }
    },
    // 展厅导览页-点击详情
    exhibition_page_detail_click(name, product_tag, industry_tag, exhibition_name){
        if(this.isPc){
            // console.log('maima, pc_exhibition_page_detail_click', name, product_tag, industry_tag, exhibition_name);
            _hw("send", "action", "pc_exhibition_page_detail_click", {
                pc_exhibition_hall_name: name,
                pc_product_tag: product_tag,
                pc_industry_tag: industry_tag,
                pc_exhibition_name: exhibition_name,
            });
        }else{
            // console.log('maima, wap_exhibition_page_detail_click', name, product_tag, industry_tag, exhibition_name);
            _hw("send", "action", "wap_exhibition_page_detail_click", {
                wap_exhibition_hall_name: name,
                wap_product_tag: product_tag,
                wap_industry_tag: industry_tag,
                wap_exhibition_name: exhibition_name,
            });
        }
    },
    // 资料中心页-点击顶部tab按钮
    material_page_top_tab_click(name){
        if(this.isPc){
            // console.log('maima, pc_material_page_top_tab_click', name);
            _hw("send", "action", "pc_material_page_top_tab_click", {
                pc_material_type: name,
            });
        }else{
            // console.log('maima, wap_material_page_top_tab_click', name);
            _hw("send", "action", "wap_material_page_top_tab_click", {
                pc_material_type: name,
            });
        }
    },
    // 资料中心页-点击全部下载
    material_page_downloadall_click(name, type, product_tag='', industry_tag=''){
        if(this.isPc){
            // console.log('maima, pc_material_page_downloadall_click', name, type, product_tag, industry_tag);
            _hw("send", "action", "pc_material_page_downloadall_click", {
                pc_material_name: name,
                pc_material_type: type,
                pc_product_tag: product_tag,
                pc_industry_tag: industry_tag,
            });
        }else{
            // console.log('maima, wap_material_page_downloadall_click', name, type, product_tag, industry_tag);
            _hw("send", "action", "wap_material_page_downloadall_click", {
                wap_material_name: name,
                wap_material_type: type,
                wap_product_tag: product_tag,
                wap_industry_tag: industry_tag,
            });
        }
    },
    // 资料中心页-点击在线预览
    material_page_onlinereview_click(name, type, product_tag='', industry_tag=''){
        if(this.isPc){
            // console.log('maima, pc_material_page_onlinereview_click', name, type, product_tag, industry_tag);
            _hw("send", "action", "pc_material_page_onlinereview_click", {
                pc_material_name: name,
                pc_material_type: type,
                pc_product_tag: product_tag,
                pc_industry_tag: industry_tag,
            });
        }else{
            // console.log('maima, wap_material_page_onlinereview_click', name, type, product_tag, industry_tag);
            _hw("send", "action", "wap_material_page_onlinereview_click", {
                wap_material_name: name,
                wap_material_type: type,
                wap_product_tag: product_tag,
                wap_industry_tag: industry_tag,
            });
        }
    },
    // 资料中心页-点击资料下载
    material_page_download_click(name, type, product_tag='', industry_tag=''){
        if(this.isPc){
            // console.log('maima, pc_material_page_download_click', name, type, product_tag, industry_tag);
            _hw("send", "action", "pc_material_page_download_click", {
                pc_material_name: name,
                pc_material_type: type,
                pc_product_tag: product_tag,
                pc_industry_tag: industry_tag,
            });
        }else{
            // console.log('maima, wap_material_page_download_click', name, type, product_tag, industry_tag);
            _hw("send", "action", "wap_material_page_download_click", {
                wap_material_name: name,
                wap_material_type: type,
                wap_product_tag: product_tag,
                wap_industry_tag: industry_tag,
            });
        }
    },
    // 资料中心页-点击内容类别确认
    material_page_content_confirm_click(name){
        // if(this.isPc){
        //     // console.log('maima, pc_material_page_content_confirm_click', name);
        //     _hw("send", "action", "pc_material_page_content_confirm_click", {
        //         pc_content_name: name,
        //     });
        // }else{
        //     // console.log('maima, wap_material_page_content_confirm_click', name);
        //     _hw("send", "action", "wap_material_page_content_confirm_click", {
        //         wap_content_name: name,
        //     });
        // }
        if(this.isPc){
            // console.log('maima, pc_material_filter_btn_click', name);
            _hw("send", "action", "pc_material_filter_btn_click", {
                pc_material_filter_name: name,
            });
        }else{
            // console.log('maima, wap_material_filter_btn_click', name);
            _hw("send", "action", "wap_material_filter_btn_click", {
                wap_material_filter_name: name,
            });
        }
    },
    // 资料中心页-点击邮件发送
    material_page_send_email_click(name, type, email){
        if(this.isPc){
            // console.log('maima, pc_material_page_send_email_click', name, type, email);
            _hw("send", "action", "pc_material_page_send_email_click", {
                pc_material_name: name,
                pc_material_type: type,
                customer_email: email,
            });
        }else{
            // console.log('maima, wap_material_page_send_email_click', name, type, email);
            _hw("send", "action", "wap_material_page_send_email_click", {
                wap_material_name: name,
                wap_material_type: type,
                customer_email: email,
            });
        }
    },
    // 生态伙伴页-点击公司名称
    partner_page_company_click(name, type){
        if(this.isPc){
            // console.log('maima, pc_partner_page_company_click', name, type);
            _hw("send", "action", "pc_partner_page_company_click", {
                pc_sponsor_name: name,
                pc_sponsor_type: type,
            });
        }else{
            // console.log('maima, wap_partner_page_company_click', name, type);
            _hw("send", "action", "wap_partner_page_company_click", {
                wap_sponsor_name: name,
                wap_sponsor_type: type,
            });
        }
    },
    // 点击侧边栏-猜你喜欢按钮
    recommendation_tab_click(name='猜你喜欢'){
        if(this.isPc){
            // console.log('maima, pc_recommendation_tab_click', name);
            _hw("send", "action", "pc_recommendation_tab_click", {
                pc_side_btn_name: name,
            });
        }else{
            // console.log('maima, wap_recommendation_tab_click', name);
            _hw("send", "action", "wap_recommendation_tab_click", {
                wap_side_btn_name: name,
            });
        }
    },
    // 点击侧边栏-项目咨询按钮
    consult_tab_click(name='项目咨询'){
        if(this.isPc){
            // console.log('maima, pc_consult_tab_click', name);
            _hw("send", "action", "pc_consult_tab_click", {
                pc_side_btn_name: name,
            });
        }else{
            // console.log('maima, wap_consult_tab_click', name);
            _hw("send", "action", "wap_consult_tab_click", {
                wap_side_btn_name: name,
            });
        }
    },
    // 点击侧边栏-线上展厅按钮
    exhibition_tab_click(name='线上展厅'){
        if(this.isPc){
            // console.log('maima, pc_exhibition_tab_click', name);
            _hw("send", "action", "pc_exhibition_tab_click", {
                pc_side_btn_name: name,
            });
        }else{
            // console.log('maima, wap_exhibition_tab_click', name);
            _hw("send", "action", "wap_exhibition_tab_click", {
                wap_side_btn_name: name,
            });
        }
    },
    // 首页_点击个性化推荐议程部分
    index_recommendation_agenda_btn_click(name, product_tag='', industry_tag=''){
        if(this.isPc){
            // console.log('maima, pc_index_recommendation_exhibition_btn_click', name, product_tag, industry_tag);
            _hw("send", "action", "pc_index_recommendation_exhibition_btn_click", {
                pc_recommendation_agenda_name: name,
                pc_product_tag: product_tag,
                pc_industry_tag: industry_tag,
            });
        }else{
            // console.log('maima, wap_index_recommendation_exhibition_btn_click', name, product_tag, industry_tag);
            _hw("send", "action", "wap_index_recommendation_exhibition_btn_click", {
                wap_recommendation_agenda_name: name,
                wap_product_tag: product_tag,
                wap_industry_tag: industry_tag,
            });
        }
    },
    // 首页_点击个性化推荐资料部分
    index_recommendation_material_btn_click(name, product_tag='', industry_tag=''){
        if(this.isPc){
            // console.log('maima, pc_index_recommendation_material_btn_click', name, product_tag, industry_tag);
            _hw("send", "action", "pc_index_recommendation_material_btn_click", {
                pc_recommendation_material_name: name,
                pc_product_tag: product_tag,
                pc_industry_tag: industry_tag,
            });
        }else{
            // console.log('maima, wap_index_recommendation_material_btn_click', name, product_tag, industry_tag);
            _hw("send", "action", "wap_index_recommendation_material_btn_click", {
                wap_recommendation_material_name: name,
                wap_product_tag: product_tag,
                wap_industry_tag: industry_tag,
            });
        }
    },
    // 首页_点击个性化推荐展馆部分
    index_recommendation_exhibition_btn_click(name, product_tag='', industry_tag=''){
        if(this.isPc){
            // console.log('maima, pc_index_recommendation_exhibition_btn_click', name, product_tag, industry_tag);
            _hw("send", "action", "pc_index_recommendation_exhibition_btn_click", {
                pc_recommendation_exhibition_name: name,
                pc_product_tag: product_tag,
                pc_industry_tag: industry_tag,
            });
        }else{
            // console.log('maima, wap_index_recommendation_exhibition_btn_click', name, product_tag, industry_tag);
            _hw("send", "action", "wap_index_recommendation_exhibition_btn_click", {
                wap_recommendation_exhibition_name: name,
                wap_product_tag: product_tag,
                wap_industry_tag: industry_tag,
            });
        }
    },
    // 个人中心页-点击顶部tab
    mine_toptab_click(name){
        if(this.isPc){
            // console.log('maima, pc_mine_toptab_click', name);
            _hw("send", "action", "pc_mine_toptab_click", {
                pc_mine_top_btn_name: name,
            });
        }else{
            // console.log('maima, wap_mine_toptab_click', name);
            _hw("send", "action", "wap_mine_toptab_click", {
                wap_mine_top_btn_name: name,
            });
        }
    },
    // 个人中心-点击取消预约
    mine_mine_cancel_click(name, product_tag='', industry_tag=''){
        if(this.isPc){
            // console.log('maima, pc_mine_mine_cancel_click', name, product_tag, industry_tag);
            _hw("send", "action", "pc_mine_mine_cancel_click", {
                pc_meeting_name: name,
                pc_product_tag: product_tag,
                pc_industry_tag: industry_tag,
            });
        }else{
            // console.log('maima, wap_mine_mine_cancel_click', name, product_tag, industry_tag);
            _hw("send", "action", "wap_mine_mine_cancel_click", {
                wap_meeting_name: name,
                wap_product_tag: product_tag,
                wap_industry_tag: industry_tag,
            });
        }
    },
    // 个人中心下载页-点击在线预览
    mine_onlinereview_click(name, product_tag='', industry_tag=''){
        if(this.isPc){
            // console.log('maima, pc_mine_onlinereview_click', name, product_tag, industry_tag);
            _hw("send", "action", "pc_mine_onlinereview_click", {
                pc_material_name: name,
                pc_product_tag: product_tag,
                pc_industry_tag: industry_tag,
            });
        }else{
            // console.log('maima, wap_mine_onlinereview_click', name, product_tag, industry_tag);
            _hw("send", "action", "wap_mine_onlinereview_click", {
                wap_material_name: name,
                wap_product_tag: product_tag,
                wap_industry_tag: industry_tag,
            });
        }
    },
    // 个人中心下载页-点击资料下载
    mine_download_click(name, product_tag='', industry_tag=''){
        if(this.isPc){
            // console.log('maima, pc_mine_download_click', name, product_tag, industry_tag);
            _hw("send", "action", "pc_mine_download_click", {
                pc_material_name: name,
                pc_product_tag: product_tag,
                pc_industry_tag: industry_tag,
            });
        }else{
            // console.log('maima, wap_mine_download_click', name, product_tag, industry_tag);
            _hw("send", "action", "wap_mine_download_click", {
                wap_material_name: name,
                wap_product_tag: product_tag,
                wap_industry_tag: industry_tag,
            });
        }
    },
    // 个人中心下载页-点击发送按钮
    send_material_btn_click(name, product_tag='', industry_tag='', email){
        if(this.isPc){
            // console.log('maima, pc_send_material_btn_click', name, product_tag, industry_tag, email);
            _hw("send", "action", "pc_send_material_btn_click", {
                customer_email: email,
                pc_material_name: name,
                pc_product_tag: product_tag,
                pc_industry_tag: industry_tag,
            });
        }else{
            // console.log('maima, wap_send_material_btn_click', name, product_tag, industry_tag, email);
            _hw("send", "action", "wap_send_material_btn_click", {
                customer_email: email,
                wap_material_name: name,
                wap_product_tag: product_tag,
                wap_industry_tag: industry_tag,
            });
        }
    },
    // 个人中心下载页-点击取消收藏展馆
    mine_cancel_click(name, product_tag='', industry_tag=''){
        if(this.isPc){
            // console.log('maima, pc_mine_cancel_click', name, product_tag, industry_tag);
            _hw("send", "action", "pc_mine_cancel_click", {
                pc_exhibition_name: name,
                pc_product_tag: product_tag,
                pc_industry_tag: industry_tag,
            });
        }else{
            // console.log('maima, wap_mine_cancel_click', name, product_tag, industry_tag);
            _hw("send", "action", "wap_mine_cancel_click", {
                wap_exhibition_name: name,
                wap_product_tag: product_tag,
                wap_industry_tag: industry_tag,
            });
        }
    },
    // 展厅导览页-搜索
    exhibition_page_search_click(keywords){
        if(this.isPc){
            // console.log('maima, pc_exhibition_page_search_click', keywords);
            _hw("send", "action", "pc_exhibition_page_search_click", {
                pc_search_keyword: keywords,
            });
        }else{
            // console.log('maima, wap_exhibition_page_search_click', keywords);
            _hw("send", "action", "wap_exhibition_page_search_click", {
                wap_search_keyword: keywords,
            });
        }
    },
    // 展厅导览页-点击去注册
    exhibition_page_register_click(){
        if(this.isPc){
            // console.log('maima, pc_exhibition_page_register_click');
            _hw("send", "action", "pc_exhibition_page_register_click");
        }else{
            // console.log('maima, wap_exhibition_page_register_click');
            _hw("send", "action", "wap_exhibition_page_register_click");
        }
    },
    // 直播中首页_点击进入直播间
    live_homepage_attend_btn_click(live_title, product_tag='', industry_tag=''){
        if(this.isPc){
            // console.log('maima, pc_live_homepage_attend_btn_click', live_title, product_tag, industry_tag);
            _hw("send", "action", "pc_live_homepage_attend_btn_click", {
                live_title: live_title,
                product_tag: product_tag,
                industry_tag: industry_tag,
            });
        }else{
            // console.log('maima, wap_live_homepage_attend_btn_click', live_title, product_tag, industry_tag);
            _hw("send", "action", "wap_live_homepage_attend_btn_click", {
                live_title: live_title,
                product_tag: product_tag,
                industry_tag: industry_tag,
            });
        }
    },
    // 直播中首页_点击切换日期
    live_page_schedule_date_click(){
        if(this.isPc){
            // console.log('maima, pc_live_page_schedule_date_click');
            _hw("send", "action", "pc_live_page_schedule_date_click");
        }else{
            // console.log('maima, wap_live_page_schedule_date_click');
            _hw("send", "action", "wap_live_page_schedule_date_click");
        }
    },
    // 直播中首页_点击5类议程类型按钮
    live_page_agenda_type_click(name, product_tag='', industry_tag=''){
        if(this.isPc){
            // console.log('maima, pc_live_page_agenda_type_click', name, product_tag, industry_tag);
            _hw("send", "action", "pc_live_page_agenda_type_click", {
                pc_live_meeting_type: name,
                product_tag: product_tag,
                industry_tag: industry_tag,
            });
        }else{
            // console.log('maima, wap_live_page_agenda_type_click', name, product_tag, industry_tag);
            _hw("send", "action", "wap_live_page_agenda_type_click", {
                wap_live_meeting_type: name,
                product_tag: product_tag,
                industry_tag: industry_tag,
            });
        }
    },
    
};
export default maima;
